import { api } from '@/api/endpoints';
import { NetworkError } from '@/api/client';
import { KV, db, getStoredUser, replaceServerEstimates, setKv } from './database';

/**
 * Pull master data and recent estimates from the pack house into Dexie. An admin also gets
 * the grower list and the variety harvest weeks.
 * Returns false when there was no signal; throws on anything else.
 */
export async function pullFromServer(): Promise<boolean> {
  try {
    const user = await getStoredUser();
    const [master, estimates] = await Promise.all([api.masterData(), api.estimates.list(4)]);
    await db.transaction('rw', db.kv, db.estimates, async () => {
      await setKv(KV.masterData, master);
      await replaceServerEstimates(estimates);
      await setKv(KV.lastServerSync, new Date().toISOString());
    });
    if (user?.role === 'admin') await pullAdminData();
    return true;
  } catch (err) {
    if (err instanceof NetworkError) return false;
    throw err;
  }
}

/** Admin only: refresh the grower list and the variety harvest weeks on the phone. */
export async function pullAdminData(): Promise<void> {
  const [growers, harvestWeeks, userFarms] = await Promise.all([
    api.admin.growers(),
    api.admin.harvestWeeks.list(),
    api.admin.userFarms.list(),
  ]);
  await db.transaction('rw', db.kv, async () => {
    await setKv(KV.adminGrowers, growers);
    await setKv(KV.adminHarvestWeeks, harvestWeeks);
    await setKv(KV.adminUserFarms, userFarms);
  });
}
